module.exports = __webpack_public_path__ + "static/freeapp-admin-help-cacd77a74aca0647c8db49a274450e68.png";